<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title>
            <v-icon>mdi-clipboard-text</v-icon>Print Prescription
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn text :to="'/prescription/view/' + this.id">
              <v-icon>mdi-arrow-left</v-icon>Back
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <pdf-viewer url="prescriptions/quote" :params="{ id: this.id }"></pdf-viewer>
      </v-card>
    </div>
  </div>
</template>

<script>
import PdfViewer from "@components/PdfViewer.vue";
export default {
  components: {
    PdfViewer
  },
  data() {
    return {
      id: this.$route.params.id
    };
  }
};
</script>

<style></style>
